import * as Yup from "yup";

export function initialValues(permission) {
  return {
    name: permission?.name || "",
    action: permission?.action || "",
    description: permission?.description || "",
    section: permission?.section || "",
    active: permission?.active || true,
  };
}

export function validationSchema() {
  return Yup.object({
    name: Yup.string().required("El nombre es obligatorio"),
    action: Yup.string()
      .required("La acción es obligatoria")
      .matches(
        /^[a-zA-Z]+\.[a-zA-Z]+$/,
        "El formato debe ser palabra.palabra (ej: usuarios.crear)"
      ),
    description: Yup.string().required("La descripción es obligatoria"),
    section: Yup.string().required("La sección es obligatoria"),
    active: Yup.boolean().required(true),
  });
}
